import { formatCount } from '@/lib/numbers';

import type { DailyPoint } from './dashboardData';
import { formatDay } from './dateRange';

/** Describes the picture in words: category, range, total and the highest day. */
export function describeTrend(label: string, points: DailyPoint[]): string {
  const first = points[0];
  const last = points[points.length - 1];
  const total = points.reduce((sum, point) => sum + point.value, 0);
  const highest = points.reduce((top, point) => (point.value > top.value ? point : top));
  return (
    `${label}, daily activity from ${formatDay(first.date)} to ${formatDay(last.date)}: ` +
    `${formatCount(total)} in total, highest ${formatCount(highest.value)} on ${formatDay(highest.date)}`
  );
}
